import { render, staticRenderFns } from "./NFTSideMenu.vue?vue&type=template&id=fe52c908&scoped=true&"
import script from "./NFTSideMenu.vue?vue&type=script&lang=js&"
export * from "./NFTSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./NFTSideMenu.vue?vue&type=style&index=0&id=fe52c908&lang=scss&scoped=true&"
import style1 from "./NFTSideMenu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe52c908",
  null
  
)

export default component.exports